// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LevelOfImprovementObtainedStats_bgBlue__gfD\\+B {
  background-color: #d0e0e3;
}

.LevelOfImprovementObtainedStats_bgGreen__N\\+gCm {
  background-color: #d9ead3;
}

.LevelOfImprovementObtainedStats_leftSeparator__2CiZG {
  border-left: solid 4px #000 !important;
}

.LevelOfImprovementObtainedStats_statsTitle__nGShW {
  text-transform: uppercase;
}

.LevelOfImprovementObtainedStats_uppercase__YM\\+xY {
  text-transform: uppercase !important;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/LevelOfImprovementObtainedStats/LevelOfImprovementObtainedStats.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,sCAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,oCAAA;AACF","sourcesContent":[".bgBlue {\n  background-color: #d0e0e3;\n}\n\n.bgGreen {\n  background-color: #d9ead3;\n}\n\n.leftSeparator {\n  border-left: solid 4px #000 !important;\n}\n\n.statsTitle {\n  text-transform: uppercase;\n}\n\n.uppercase {\n  text-transform: uppercase !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bgBlue": `LevelOfImprovementObtainedStats_bgBlue__gfD+B`,
	"bgGreen": `LevelOfImprovementObtainedStats_bgGreen__N+gCm`,
	"leftSeparator": `LevelOfImprovementObtainedStats_leftSeparator__2CiZG`,
	"statsTitle": `LevelOfImprovementObtainedStats_statsTitle__nGShW`,
	"uppercase": `LevelOfImprovementObtainedStats_uppercase__YM+xY`
};
export default ___CSS_LOADER_EXPORT___;
